module.exports = require("nprogress");